// Stand-in for bepAnalytics when the analytics module isn't loaded (server-side
// render, or window.ha.siteName missing on the client). Several steps call
// analytics.* unguarded inside a synchronous mount effect, and a throw there
// propagates through commit and unmounts the React root — a blank page.
export default {
    viewTTIstart: () => {},
    viewTTIstop: () => {},
    setAnalyticsPageName: () => {}
};
